export const GET_ACTIVE_USER_PROFILE_BEGIN = "GET_ACTIVE_USER_PROFILE_BEGIN"
export const GET_ACTIVE_USER_PROFILE_ERROR = "GET_ACTIVE_USER_PROFILE_ERROR"
export const GET_ACTIVE_USER_PROFILE_SUCCESS = "GET_ACTIVE_USER_PROFILE_SUCCESS"

export const POST_USERPROFILE_BEGIN = "POST_USERPROFILE_BEGIN"
export const POST_USERPROFILE_ERROR = "POST_USERPROFILE_ERROR"
export const POST_USERPROFILE_SUCCESS = "POST_USERPROFILE_SUCCESS"

export const CHANGE_USERPROFILE_SETTING = "CHANGE_USERPROFILE_SETTING"